import PathType from "../../../consts/pathmodule/PathType";
import { IJobResumeDto } from "./IJobResumeDto";
import PathJobResumeGroupDto from "./PathJobResumeGroupDto";

export default class PathSynchroJobResumeDto extends IJobResumeDto {
    ToAdd: number;
    ToUpdate: number;
    ToDelete: number;
    ToIgnore: number;
    Added: number;
    Updated: number;
    Deleted: number;
    Ignored: number;
    Groups: PathJobResumeGroupDto[];

    constructor(
        toAdd: number,
        toUpdate: number,
        toDelete: number,
        toIgnore: number,
        added: number,
        updated: number,
        deleted: number,
        ignored: number,
        groups: PathJobResumeGroupDto[]) {
        super(PathType.DataSynchronization);
        this.ToAdd = toAdd;
        this.ToUpdate = toUpdate;
        this.ToDelete = toDelete;
        this.ToIgnore = toIgnore;
        this.Added = added;
        this.Updated = updated;
        this.Deleted = deleted;
        this.Ignored = ignored;
        this.Groups = groups;
    }
}